import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import sampleData from './sampleData.json';





export const actionTypes = {
  selectShoab: "[selectShoab] Action",
  selectShoabEmpty: "[selectShoabEmpty] Action",
  selectShoabAsync: "[selectShoabAsync] Action",
  selectShoabLoading: "[selectShoabLoading] Action",
}

const initialState = {
  data: sampleData?sampleData:[],
  size: 20,
  total: 10000,
  loading: false
}


export const select_shoab_reducer = (state = initialState, { type, payload }) => {
  
  switch (type) {
    case actionTypes.selectShoab:
      return {
        ...state,
        data: payload.results,
        total: payload.total ? payload.total : state.total
      };
    case actionTypes.selectShoabLoading:
      return {
        ...state,
        loading: payload,
      };
    case actionTypes.selectShoabEmpty:
      return initialState
    default:
      return state;
  }
}



function* handleWorker({ payload }) {

  let config = {
    url: "select_request"
  };

  let data = {
    table: "shoab",
    method_type: "select",
    from: payload?.from ? (payload.from - 1) * payload.size : 0,
    size: payload?.size,
    data: payload?.data ? payload.data : {},
    sort_by: payload?.sort_by ? payload?.sort_by : {},
  };

  yield put({ type: actionTypes.selectShoabLoading, payload: true });

  try {

    let res = yield AxiosCustom(config, data);

    //   let flag = handleNotificationAlertTrySelect(res);

    //   if (!flag) return;

    yield put({
      type: actionTypes.selectShoab,
      payload: res?.data?.response?.data
    });

  } catch {
    //   handleNotificationAlertCatch();
  } finally {
    yield put({ type: actionTypes.selectShoabLoading, payload: false });
  }
}

export function* workerSelectShoab() {
  yield takeLatest(actionTypes.selectShoabAsync, handleWorker);
}
